var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 1018 1018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M985.248 953.466h-63.564v-95.347a95.347 95.347 0 00-95.347-95.346H699.208a95.346 95.346 0 00-95.346 95.346v95.347h-63.565v-95.347a158.916 158.916 0 0146.544-112.367 158.916 158.916 0 01112.367-46.544h127.129a158.912 158.912 0 01158.911 158.911v95.347zM762.773 381.386a95.346 95.346 0 110 190.693 95.346 95.346 0 010-190.693zm0-63.564a158.91 158.91 0 10-.001 317.82 158.91 158.91 0 00.001-317.82zM476.733 699.208h-63.564v-95.346a95.346 95.346 0 00-95.347-95.347H190.693a95.347 95.347 0 00-95.346 95.347v95.346H31.782v-95.346a158.91 158.91 0 01158.911-158.911h127.129a158.91 158.91 0 01158.911 158.911v95.346zM254.258 127.129a95.346 95.346 0 11-95.347 95.346 95.347 95.347 0 0195.347-95.346zm0-63.565a158.907 158.907 0 00-146.815 98.099 158.91 158.91 0 10146.815-98.099z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClub);
export default __webpack_public_path__ + "static/media/iconClub.98a8281d20602b9777f33859830ac49d.svg";
export { ForwardRef as ReactComponent };